<router-outlet></router-outlet>
<frodo-network-activity-panel
  *ngIf="showNetworkPanel"
  (closed)="showNetworkPanel = false"
></frodo-network-activity-panel>
